import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=3d6169fb&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=ts"
export * from "./BackButton.vue?vue&type=script&lang=ts"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=3d6169fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6169fb",
  null
  
)

export default component.exports